// src/components/FullPageLoader/FullPageLoader.jsx
import React from "react";
import styles from "./FullPageLoader.module.css";

const FullPageLoader = () => {
  return (
    <div className={styles.overlay}>
      <div className={styles.spinner}></div>
    </div>
  );
};

export default FullPageLoader;
